import React from 'react';
import './PrintableSchedule.css';

const PrintableSchedule = ({ data }) => {
  const { employee, year, month, days } = data;
  const monthName = new Date(year, month - 1).toLocaleString('pl-PL', { month: 'long' });

  const formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split('-');
    return `${day.padStart(2, '0')}.${month.padStart(2, '0')}.${year}`;
  };

  const formatDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}h ${mins > 0 ? `${mins}min` : ''}`;
  };

  return (
    <div className="printable-schedule">
      <div className="schedule-header">
        <h2>Ewidencja godzin - {monthName} {year}</h2>
        <p>Zleceniobiorca: {(employee.first_name && employee.last_name) ? `${employee.first_name} ${employee.last_name}` : employee.username || ''}</p>
      </div>

      <table className="schedule-table">
        <thead>
          <tr>
            <th>Data</th>
            <th>Dzień tygodnia</th>
            <th>Lokalizacja</th>
            <th>Czas pracy</th>
            <th>Podpis</th>
          </tr>
        </thead>
        <tbody>
          {days.map(day => (
            <tr key={day.date}>
              <td>{formatDate(day.date)}</td>
              <td>{day.weekday}</td>
              <td>
                {day.shifts.length > 0 ? (
                  day.shifts.map((shift, index) => (
                    <div key={index}>{shift.location_name}</div>
                  ))
                ) : (
                  "-"
                )}
              </td>
              <td>
                {day.shifts.length > 0 ? (
                  day.shifts.map((shift, index) => (
                    <div key={index}>
                      {formatDuration(shift.duration_minutes)}
                    </div>
                  ))
                ) : (
                  "-"
                )}
              </td>
              <td className="signature-cell"></td>
            </tr>
          ))}
          <tr className="signature-row">
            <td colSpan="5">
              <div className="signatures-in-table">
                <div className="signature-line">
                  <span>Podpis zleceniobiorcy</span>
                </div>
                <div className="signature-line">
                  <span>Podpis przełożonego</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PrintableSchedule;
